/**
 * Validador de requests para evitar errores de "Input inválido"
 */

/**
 * Valida los datos para el registro interno
 * @param {object} data - Datos del request
 * @returns {object} - { isValid: boolean, errors: string[] }
 */
export const validateInternalRegistrationData = (data) => {
  const errors = [];
  
  // Validar token del evento
  if (!data.token || typeof data.token !== 'string') {
    errors.push('Token del evento requerido');
  } else if (data.token.trim().length === 0) {
    errors.push('Token del evento no puede estar vacío');
  }
  
  // Validar email
  if (!data.email || typeof data.email !== 'string') {
    errors.push('Email requerido');
  } else if (!isValidEmail(data.email)) {
    errors.push('Email inválido');
  }
  
  // Validar token de Google
  if (!data.googleToken || typeof data.googleToken !== 'string') {
    errors.push('Token de Google requerido');
  } else if (data.googleToken.split('.').length !== 3) {
    errors.push('Token de Google con formato inválido');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Sanitiza los datos del request removiendo caracteres problemáticos
 * @param {object} data - Datos a sanitizar
 * @returns {object} - Datos sanitizados
 */
export const sanitizeRequestData = (data) => {
  const sanitized = {};
  
  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'string') {
      // Remover caracteres de control y espacios extra
      sanitized[key] = value.trim().replace(/[\x00-\x1F\x7F]/g, '');
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
};

/**
 * Valida formato de email
 * @param {string} email - Email a validar
 * @returns {boolean} - True si es válido
 */
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Valida que un eventId sea válido
 * @param {string} eventId - ID del evento
 * @returns {boolean} - True si es válido
 */
export const isValidEventId = (eventId) => {
  return eventId && 
         typeof eventId === 'string' && 
         eventId.trim().length > 0 && 
         eventId !== 'undefined' && 
         eventId !== 'null';
};